import React from "react";
import styles from "./ui.module.scss";
import { useEventStore } from "../../store";
import { get_city_label, getByPos } from "../../../../utils/misc";
import { IBloodStation } from "../../../profileThankYouPage/profileThankYouPage";

const EventAddress: React.FC<{ data?: IBloodStation }> = ({ data = null }) => {
  const { eventData } = useEventStore();

  if (!data) if (!eventData?.address) return null;

  const cityLabel = data
    ? get_city_label(data.city)
    : get_city_label(eventData.city);

  const sendTo = (endLat, endLng) => {
    getByPos()
      .then((r) => {
        const { coords } = r;
        if (typeof window !== "undefined") {
          const sendTo = `https://yandex.ru/maps/?mode=routes&rtext=${coords.latitude}%2C${coords.longitude}~${endLat}%2C${endLng}&rtt=auto`;
          const win = window.open(sendTo, "_blank");
          win.focus();
        }
      })
      .catch(() => {
        if (typeof window !== "undefined") {
          const sendTo = `https://yandex.ru/maps/?mode=routes&rtext=${endLat}%2C${endLng}~${endLat}%2C${endLng}&rtt=auto`;
          const win = window.open(sendTo, "_blank");
          win.focus();
        }
      });
  };

  let content;

  if (data)
    content = (
      <div className={styles.EventAddress_Text}>
        <span>{[cityLabel, data.address].filter(Boolean).join(", ")}</span>
        <div>
          <p
            onClick={() => {
              sendTo(data.lat, data.lng);
            }}
          >
            Проложить маршрут
          </p>
        </div>
      </div>
    );
  else
    content = (
      <div className={styles.EventAddress_Text}>
        <span>{[cityLabel, eventData.address].filter(Boolean).join(", ")}</span>
        {eventData?.category?.id === 1 && eventData?.city && (
          <div>
            <p
              onClick={() => {
                sendTo(
                  eventData.blood_station.lat,
                  eventData.blood_station.lng
                );
              }}
            >
              Проложить маршрут
            </p>
          </div>
        )}
      </div>
    );
  return (
    <div className={styles.EventAddress}>
      <div className={styles.EventAddress_Image}>
        <svg
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M12 12.75C13.6569 12.75 15 11.4069 15 9.75C15 8.09315 13.6569 6.75 12 6.75C10.3431 6.75 9 8.09315 9 9.75C9 11.4069 10.3431 12.75 12 12.75Z"
            stroke="#4E5355"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M19.5 9.75C19.5 16.5 12 21.75 12 21.75C12 21.75 4.5 16.5 4.5 9.75C4.5 7.76088 5.29018 5.85322 6.6967 4.4467C8.10322 3.04018 10.0109 2.25 12 2.25C13.9891 2.25 15.8968 3.04018 17.3033 4.4467C18.7098 5.85322 19.5 7.76088 19.5 9.75V9.75Z"
            stroke="#4E5355"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      </div>
      {content}
    </div>
  );
};

export default EventAddress;
